import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import SysAdminTenantTableContainer from '../containers/sysadmin-tenant-table.container';
import SysAdminTenantDetailsContainer from '../containers/sysadmin-tenant-details.container';
import SysAdminTenantCreateContainer from '../containers/sysadmin-tenant-create.container';
import SysAdminTenantUpdateContainer from '../containers/sysadmin-tenant-update.container';
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_PAGE,
} from '../../../../../const/default-paginated-table-data.const';

// Helper function to add default query parameters to the tenant list page
const SysAdminTenantListWithParams = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Set default params if they don't exist
  if (!params.has('page')) {
    params.set('page', DEFAULT_PAGINATION_PAGE.toString());
  }
  if (!params.has('limit')) {
    params.set('limit', DEFAULT_PAGINATION_LIMIT.toString());
  }

  // If query params need to be added
  if (location.search !== `?${params.toString()}`) {
    return <Navigate to={`?${params.toString()}`} replace />;
  }

  return <SysAdminTenantTableContainer />;
};

export const sysadminTenantRoutes = [
  {
    path: 'admin/tenant',
    element: <SysAdminTenantListWithParams />,
  },
  {
    path: 'admin/tenant/create',
    element: <SysAdminTenantCreateContainer />,
  },
  {
    path: 'admin/tenant/:id',
    element: <SysAdminTenantDetailsContainer />,
  },
  {
    path: 'admin/tenant/:id/update',
    element: <SysAdminTenantUpdateContainer />,
  },
];

export default sysadminTenantRoutes;
